import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { fg } from '@confluence/feature-gating';
import { HOME } from '@confluence/named-routes';
import type { RouteMatch } from '@confluence/route';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection';
import { AISearchPage } from '@confluence/rovo-ai-search/entry-points/AISearchPage';

export const AISearchRoute = () => {
	if (!fg('rovo_ai_mode_enabled')) {
		return <Redirection name={HOME.name} />;
	}

	return <AISearchPage />;
};

AISearchRoute.NAVIGATION_PARAMS = (routeMatch: RouteMatch) => {
	const aiSearchQuery = routeMatch?.query?.aiSearchQuery ?? '';
	return {
		Screen: {
			screenEvent: { name: 'aiSearchPageScreen' },
			pageState: {
				aiSearchQuery,
			},
		},
		MainLayout: {
			navView: PRODUCT_HOME_ID,
			aiSearchQuery,
		},
	};
};
